// extracted by mini-css-extract-plugin
module.exports = {"repeat-btn":"AudioRepeatCheckbox_repeat-btn__PhWxV","repeat-ckb":"AudioRepeatCheckbox_repeat-ckb__3UYAy","repeat-ckb-icon":"AudioRepeatCheckbox_repeat-ckb-icon__3WK8F"};